import React from 'react'
import { Button, Col, Form, FormGroup, Input, Label, Row, Table } from 'reactstrap'
import { GeoAltFill } from 'react-bootstrap-icons'

const ContactInfo = () => {

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <div id='website-responsive'  >
            <div className='marginAll mb-5 mt-md-5' style={{ backgroundColor: '#', }}>
                <Row className='padding3xem pt-md-3' style={{ padding: '' }}>
                    <Col md='12' lg='6'>
                        <div className=''>
                            <text className='fs-ss-30 fw-700 text-montserrat text-ss-primary'>
                                GET IN TOUCH
                            </text>
                        </div>

                        <hr className='hr-style my-md-2' style={{ width: '80px', marginTop: '2px', marginBottom: '4px' }} />

                        <div>
                            <text className='fs-ss-18 fw-600 text-ss-black text-montserrat' style={{ fontStyle: 'italic' }}>
                                Send us a message
                            </text>
                        </div>
                        <Form style={{ marginTop: '2rem' }}>
                            <FormGroup>



                                <Input className='text-poppins py-2' style={{ backgroundColor: '#f9f9f9' }} type='text' placeholder='Name*' required />


                            </FormGroup>

                            <FormGroup>



                                <Input className='text-poppins' style={{ backgroundColor: '#f9f9f9' }} type='email' placeholder=' Email*' required />



                            </FormGroup>

                            <FormGroup>

                                {/* <Label className='text-poppins fs-ss-12 fw-700' style={{ color:'#777771'}} for="exampleEmail">
                            
                        </Label> */}

                                <Input className='text-poppins' style={{ backgroundColor: '#f9f9f9' }} type='number' placeholder='Phone Number*' required />



                            </FormGroup>

                            <FormGroup>

                                {/* <Label className='text-poppins fs-ss-12 fw-700' style={{ color:'#777771'}} for="exampleEmail">
                           
                        </Label> */}

                                <Input className='text-poppins' style={{ backgroundColor: '#f9f9f9' }} type='textarea' placeholder='Your Message' rows={5} />



                            </FormGroup>

                            <Button type='submit' onClick={handleSubmit} className='btn-full-width' style={{ backgroundColor: '#0e70a9', boxShadow: '1px 1px 8px 0 rgba(0,0,0,.3)', borderRadius: '0px', border: 'none' }}>
                                <text className='fs-ss-16 text-montserrat fw-600 px-2'>
                                    SUBMIT
                                </text>
                            </Button>
                        </Form>
                    </Col>

                    <Col md='12' lg='5' className='contact-tablemargin ms-lg-5 mt-5 mt-md-5  ' style={{ borderStyle: '', borderColor: '#' }}>
                        <div className='bg-im bg-size-1' style={{ backgroundImage: 'url("pathogen-testing/Contact-Us-bg-v2.png")', backgroundSize: '', height: '%', width: '%', backgroundRepeat: 'no-repeat', padding: '' }}>

                            <div className='ptop-img flex-center'>
                                <img src='contact/United-Lab-Care-icon-v1.png' alt='contact' height='auto' width='100px' /> 
                            </div>

                            <div className='pt-4' style={{ textAlign: 'center', paddingTop: '' }}>
                                <div className=''>
                                    <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                        Phone
                                    </div>
                                </div>


                                <div className='pb-md-5 pb-3'>
                                    <a href='tel: (800) 442-1663' style={{ textDecoration: 'none' }} className='fs-ss-18 text-montserrat fw-600 text-white'>
                                        (800) 442-1663
                                    </a>
                                </div>

                                <div className=''>
                                    <div className='fs-ss-20 text-montserrat fw-700 text-white'>
                                        Email
                                    </div>
                                </div>

                                <div className='pb-md-5 pb-4'>
                                    <a href='mailto: info@unitedlabcare.com' style={{ textDecoration: 'none' }} className='fs-ss-18 text-montserrat fw-600 text-white'>
                                        info@unitedlabcare.com
                                    </a>
                                </div>


                            </div>
                        </div>

                    </Col>
                </Row>
                <Row className='padding3xem pb-5'>

                    <div className=''>
                        <text className='fs-ss-26 fw-700 text-montserrat text-ss-primary'>
                            LOCATION
                        </text>
                        <hr className='hr-style my-md-2' style={{ width: '80px', marginTop: '2px', marginBottom: '4px' }} />
                    </div>


                    <div className='mt-3'>
                        <GeoAltFill className='me-3 text-ss-primary fs-ss-20'/>
                        <text className='fs-ss-18 text-montserrat fw-600 text-ss-black display-flex'>
                            246 E Janata Blvd, Suite 115, Lombard, IL 60148
                        </text>
                    </div>
                    <div style={{ marginTop: '1.6rem' }}>
                        <iframe title='United Lab Care' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d23778.055555501203!2d-88.012268!3d41.844296!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e5275671aaaab%3A0x87314e7a64259553!2s246%20E%20Janata%20Blvd%20Suite%20115%2C%20Lombard%2C%20IL%2060148!5e0!3m2!1sen!2sus!4v1697084847135!5m2!1sen!2sus" width="100%" height="400" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </Row>
            </div>
        </div>
    )
}

export default ContactInfo